import React from 'react'

import SpinLoaderIcon from '../../../assets/Loaders/spin/spin-loader.svg?react'

function SpinLoader({ className }: { className?: string }): JSX.Element {
  return <SpinLoaderIcon className={className} />
}

export default SpinLoader
